import { useState } from "react";
import { aboutReviews } from "@/mocks/articles";

export default function Reputation() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentReview = aboutReviews[currentIndex];

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? aboutReviews.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev === aboutReviews.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-10 max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            【媒体与用户口碑】
          </h2>
          <div className="w-16 h-0.5 bg-accent-500 mx-auto mt-4"></div>
        </div>

        <div className="relative">
          <div className="flex items-start gap-6">
            <div className="flex-shrink-0">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold">
                <i className="ri-star-fill text-accent-400 w-4 h-4 flex items-center justify-center"></i>
                <span>{currentReview.spicyLevel} 好评</span>
              </div>
            </div>

            <div className="flex-1 min-w-0">
              <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed font-heading italic">
                &ldquo;{currentReview.content}&rdquo;
              </blockquote>

              <div className="flex items-center gap-3 mt-8">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={currentReview.avatarUrl}
                    alt={currentReview.username}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">
                    {currentReview.username}
                  </p>
                  <p className="text-xs text-foreground-400">
                    {currentReview.date}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-6">
            <button
              onClick={goPrev}
              className="w-10 h-10 rounded-lg border border-foreground-300 flex items-center justify-center cursor-pointer hover:bg-background-100 transition-colors duration-200"
              aria-label="上一条"
            >
              <i className="ri-arrow-left-line text-foreground-700 w-5 h-5 flex items-center justify-center"></i>
            </button>
            <button
              onClick={goNext}
              className="w-10 h-10 rounded-lg bg-foreground-900 flex items-center justify-center cursor-pointer hover:bg-foreground-950 transition-colors duration-200"
              aria-label="下一条"
            >
              <i className="ri-arrow-right-line text-background-50 w-5 h-5 flex items-center justify-center"></i>
            </button>
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {aboutReviews.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`w-2 h-2 rounded-full cursor-pointer transition-all duration-300 ${
                idx === currentIndex
                  ? "bg-accent-500 w-6"
                  : "bg-foreground-300 hover:bg-foreground-400"
              }`}
              aria-label={`第 ${idx + 1} 条评价`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}